module.exports = __webpack_public_path__ + "img/ryan.3b8e0983.png";